import Vue from 'vue';
import VueRouter from 'vue-router';
import { getURLSearchParams } from '@/utils/utils';


Vue.use(VueRouter);

const routes = [
  {
    path: '/list',
    name: 'MessageList',
    component: () => import('../pages/list.vue'),
    meta: {
      keepAlive: false,
    },
  },
  {
    path: '/commonDetail',
    name: 'MessageCommonDetail',
    component: () => import('../pages/commonDetail.vue'),
    meta: {
      keepAlive: false,
    },
  },
  {
    path: '/officeDetail',
    name: 'MessageOfficeDetail',
    component: () => import('../pages/officeDetail.vue'),
    meta: {
      keepAlive: false,
    },
  },
];

const router = new VueRouter({
  routes,
});

router.beforeEach((to, from, next) => {
  // 设置webview标题
  let title = to.meta?.title || '';
  const urlParams = getURLSearchParams();
  console.log(urlParams)
  if (urlParams && urlParams.title) {
    title = decodeURIComponent(urlParams.title);
  }
  document.title = title;
  next();
});

export default router;
